import { getAnnuityFactor } from "./getAnnuityFactor";

export const presentValue = (
	interestPerPeriod: number,
	periods: number,
	instalment: number,
) => instalment * getAnnuityFactor(interestPerPeriod, periods);
